import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from "@angular/common/http";

import { Observable, BehaviorSubject /*throwError*/ } from 'rxjs';

@Injectable()
export class AlarmsService {

  constructor(private http: HttpClient) { }

  getAlarms(orgId: string, deviceId: string, alarmType: string): Observable<any> {
   

    const params = new HttpParams()
      .set('orgUnitId', orgId)
      .set('deviceId', deviceId)
      .set('alarmType', alarmType);

    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json'
      }),
      params: params
    }


    return this.http.get<any>('/Portal/GetAlarms', httpOptions);
  }

  getAllAlarms(orgId: string, deviceId: string): Observable<any> {
    const params = new HttpParams()
      .set('orgUnitId', orgId)
      .set('deviceId', deviceId);

    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json'
      }),
      params: params
    }
    return this.http.get<any>('/Portal/GetAllAlarms', httpOptions);
  }


  getAlarmHistory(orgId: string, deviceId: string): Observable<any> {
    const params = new HttpParams()
      .set('orgUnitId', orgId)
      .set('deviceId', deviceId);

    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json'
      }),
      params: params
    }
    return this.http.get<any>('/Portal/GetAlarmHistory', httpOptions);
  }


  createAlarm(model: any): Observable<any> {

    let _body = JSON.stringify(model);

    //const params = new HttpParams()
    //  .set('orgUnitId', orgUnitId);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      //params: params
    }

    return this.http.post<any>('/Portal/CreateAlarm', _body, httpOptions);
    //.pipe(
    //  catchError(this.handleError('addHero', email))
    //);
  }

  deleteAlarm(model: any): Observable<any> {
    let _body = JSON.stringify(model);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<any>('/Portal/DeleteAlarm', _body, httpOptions);
  }

  //registerAboutYou(customer: Customer): Observable<Customer> {
    

  //  const httpOptions = {
  //    headers: new HttpHeaders({
  //      'Content-Type': 'application/json',
  //      'Accept': 'application/json'
  //    })
  //  }

  //  return this.http.post<Customer>('/Portal/UpdatePersonalInfo', _body, httpOptions);
  //  //.pipe(
  //  //  catchError(this.handleError('addHero', email))
  //  //);
  //}
}



// WEBPACK FOOTER //
// ./src/app/services/alarms-service.service.ts